module.exports = __webpack_public_path__ + "assets/img/e6db423f9a267c467fb8ef7332645f20.svg";